import styled from 'styled-components';
import { Colors, Media } from 'enums';
import { Button, Text } from 'view/atoms';

export const PageWrapper = styled.div`
  background-color: ${Colors.background};
  display: flex;
  width: 100%;
  height: 100%;
  padding: 80px 0;
`;

export const Content = styled.div`
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;

  @media ${Media.notebook} {
    width: 360px;
  }
`;

export const ErrorIcon = styled.img`
  width: 32px;
  height: 32px;

  @media ${Media.notebook} {
    width: 48px;
    height: 48px;
  }
`;

export const TitleText = styled(Text)`
  margin-top: 16px;
  @media ${Media.notebook} {
    margin-top: 32px;
  }
`;

export const DescriptionText = styled(Text)`
  margin-top: 8px;
  @media ${Media.notebook} {
    margin-top: 16px;
  }
`;

export const BackButton = styled(Button)`
  margin-top: 32px;
  @media ${Media.notebook} {
    margin-top: 48px;
  }
`;
